module.exports = __webpack_public_path__ + "img/5.b64371c8.jpg";